var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal fade",
      class: _vm.onmasive ? "show" : "show",
      style: _vm.onmasive ? "display: block; padding-left: 0px;" : "",
      attrs: { tabindex: "-1", role: "dialog" },
    },
    [
      _c("div", { staticClass: "modal-dialog modal-dialog-centered" }, [
        _c("div", { staticClass: "modal-content shadow-3" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "modal-footer" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-h btn-primary px-3",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.ACTION()
                  },
                },
              },
              [
                _vm.count == 1
                  ? _c(
                      "div",
                      {
                        staticClass: "spinner-border spinner-border-sm",
                        attrs: { role: "status" },
                      },
                      [
                        _c("span", { staticClass: "sr-only" }, [
                          _vm._v("Loading..."),
                        ]),
                      ]
                    )
                  : _c("span", [_vm._v("Continuar")]),
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-h btn-dark px-3",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.$emit("onclose")
                  },
                },
              },
              [_vm._v("Cancelar")]
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c(
        "div",
        {
          staticClass:
            "icon icon-shape rounded-3 bg-soft-primary text-primary text-lg me-4",
        },
        [_c("i", { staticClass: "bi bi-check-circle" })]
      ),
      _vm._v(" "),
      _c("div", [
        _c("h5", { staticClass: "mb-1" }, [_vm._v("Facturación masiva")]),
        _vm._v(" "),
        _c("p", [_vm._v("Todavia no se ha escaneado todos los paquetes")]),
        _vm._v(" "),
        _c("small", { staticClass: "d-block text-xs text-muted" }, [
          _vm._v("¿Realmente desea procesar la solicitud?"),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "ms-auto" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }